import { FC } from 'react';

import SunshineLoader from 'components/_core/SunshineLoader';

import { TaxForecastPeriod } from '../../hooks/useTaxForecastData';
import locales from '../../locales';
import EstimationCtaCard from '../EstimationCtaCard';
import SelectedEstimationOverview from './components/SelectedEstimationOverview';

export type EstimationOverviewProps = {
  hasCustomizedEstimation: boolean;
  isSubjectToVat: boolean;
  loading?: boolean;
  taxForecastPeriods: TaxForecastPeriod[];
};

const EstimationOverview: FC<EstimationOverviewProps> = ({
  hasCustomizedEstimation,
  isSubjectToVat,
  loading = false,
  taxForecastPeriods,
}) => {
  if (loading) {
    return <SunshineLoader />;
  }

  // Only take the current period and the previous one if available
  const customizableEstimation =
    taxForecastPeriods.length >= 2
      ? taxForecastPeriods.slice(0, 2)
      : taxForecastPeriods;

  return hasCustomizedEstimation ? (
    <SelectedEstimationOverview
      isSubjectToVAT={isSubjectToVat}
      taxForecastPeriods={customizableEstimation}
    />
  ) : (
    <EstimationCtaCard
      ctaText={locales.overview.empty.cta}
      subtitle={locales.overview.empty.subtitle}
      title={locales.overview.empty.title}
    />
  );
};

export default EstimationOverview;
